// NOTE: Prefix of a per-assistant group key, so it can never collide with the
// date-bucket keys ("today", "month-2026-05", ...).
export const ASSISTANT_CHAT_GROUP_KEY_PREFIX = "assistant-" as const;

// NOTE: Group key for assistant chats whose assistant the server could not
// resolve any more (hard-deleted). They stay reachable under one fallback group
// rather than dropping out of the list.
export const UNKNOWN_ASSISTANT_CHAT_GROUP_KEY = "assistant-unknown" as const;

// NOTE: NSAI-5867 — group key for a chat held by MORE THAN ONE assistant. The
// chat entity carries an ordered `current_assistant_ids` array, and grouping used
// to key on slot 0, so a multi-assistant conversation was filed under whichever
// assistant happened to be first and was indistinguishable from that assistant's
// own chats. One shared bucket rather than one per combination: the number of
// combinations is unbounded, and what a user needs to recognise is "this one has
// several", not which several.
export const MULTI_ASSISTANT_CHAT_GROUP_KEY = "assistant-multi" as const;

export const UNKNOWN_ASSISTANT_CHAT_GROUP_LABEL_KEY =
  "chat_list.groups.unknown_assistant" as const;

export const MULTI_ASSISTANT_CHAT_GROUP_LABEL_KEY =
  "chat_list.groups.multi_assistant" as const;
